import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { RoutePaths } from '../route-paths';
import LoanCalculator from 'pages/user/loan-calculator';
import TransportLoanCalculator from 'pages/user/loan-calculator/TransportLoanCalculator';
import SchoolLoanCalculator from 'pages/user/loan-calculator/SchoolCalculator';
import HouseRentCalculator from 'pages/user/loan-calculator/HouseRentCalculator';
import LoanAgreementPage from 'pages/home/loan-agreement/LoanAgreementPage';
const HouseRentPage = lazy(() => import('pages/home/rent'));
const LandingPage = lazy(() => import('../../pages/home/home'));
const SchoolfeesPage = lazy(
  () => import('../../pages/home/school-fee/my-child')
);

const TransportPage = lazy(() => import('../../pages/home/transport'));
const SchoolfeePage = lazy(() => import('../../pages/home/school-fee/myself'));
const TermsConditions = lazy(() => import('../../pages/termsConditions'));
const Privacy = lazy(() => import('../../pages/privacy'));
const SchoolFeeLandingPage = lazy(
  () => import('../../pages/home/school-fee/SchoolFeeLandingPage')
);
const RentLandingPage = lazy(
  () => import('../../pages/home/rent/RentLandingPage')
);
const TransportLandingPage = lazy(
  () => import('../../pages/TransportLandingPage')
);

export const homeRoutes: RouteObject[] = [
  {
    path: RoutePaths.HOMEPAGE,
    element: <LandingPage />,
  },
  {
    path: RoutePaths.TERMS_CONDITIONS,
    element: <TermsConditions />,
  },
  {
    path: RoutePaths.PRIVACY,
    element: <Privacy />,
  },
  {
    path: RoutePaths.SCHOOL_FEES,
    element: <SchoolfeesPage />,
  },
  {
    path: RoutePaths.RENT,
    element: <HouseRentPage />,
  },
  {
    path: RoutePaths.LOAN_CALCULATOR,
    element: <LoanCalculator />,
  },
  {
    path: RoutePaths.RENT_CALCULATOR,
    element: <HouseRentCalculator />,
  },
  {
    path: RoutePaths.TRANSPORT_CALCULATOR,
    element: <TransportLoanCalculator />,
  },
  {
    path: RoutePaths.SCHOOL_CALCULATOR,
    element: <SchoolLoanCalculator />,
  },
  {
    path: RoutePaths.TRANSPORT,
    element: <TransportPage />,
  },

  // school fes for myself
  {
    path: RoutePaths.LOAN_AGREEMENT,
    element: <LoanAgreementPage />,
  },
  {
    path: RoutePaths.INSTITUTION_SCHOOLFEES,
    element: <SchoolfeePage />,
  },
  { path: RoutePaths.SCHOOLFEES_GETSTARTED, element: <SchoolFeeLandingPage /> },
  { path: RoutePaths.RENT_GETSTARTED, element: <RentLandingPage /> },
  { path: RoutePaths.TRANSPORT_GETSTARTED, element: <TransportLandingPage /> },
];
